import { useEffect } from 'react';
import { OrderCard } from '../components/orders/OrderCard';
import { Button } from '../components/ui/button';
import { useAuth } from '../hooks/useAuth';
import { useOrders } from '../hooks/useOrders';
import { useAuthModal, useCart } from '../providers';

export function OrdersPage() {
  const { data: user, isLoading: authLoading } = useAuth();
  const authModal = useAuthModal();
  const cart = useCart();
  const { data: orders = [], isLoading, isError } = useOrders();

  useEffect(() => {
    let pending: string | null = null;
    try {
      pending = localStorage.getItem('c214_pending_order');
    } catch {
      // приватний режим або заблоковане сховище — нічого чистити
    }
    if (!pending) return;
    const confirmed = orders.some(
      (o) => String(o.number) === pending && o.paymentStatus === 'paid',
    );
    if (confirmed) {
      cart.clear();
      try {
        localStorage.removeItem('c214_pending_order');
      } catch {
        // приватний режим або заблоковане сховище — нічого чистити
      }
    }
  }, [orders, cart]);

  if (authLoading) return <p className="section-pad mono-label">ЗАВАНТАЖЕННЯ…</p>;

  if (!user) {
    return (
      <div className="section-pad text-center">
        <p className="mb-4 text-[15px] text-muted">Увійдіть, щоб переглянути свої замовлення.</p>
        <Button variant="accent" size="lg" onClick={() => authModal.open('login')}>
          УВІЙТИ
        </Button>
      </div>
    );
  }

  if (isLoading) return <p className="section-pad mono-label">ЗАВАНТАЖЕННЯ…</p>;
  if (isError) return <p className="section-pad mono-label">Не вдалося завантажити замовлення.</p>;

  return (
    <div className="section-pad">
      <div className="mb-8 flex items-baseline justify-between">
        <h1 className="m-0 text-[clamp(32px,6vw,72px)] font-extrabold tracking-[-0.045em]">
          Мої замовлення
        </h1>
        <p className="mono-label">ВСЬОГО ЗАМОВЛЕНЬ: {orders.length}</p>
      </div>
      {orders.length === 0 ? (
        <p className="text-[15px] text-muted">У вас ще немає замовлень.</p>
      ) : (
        orders.map((order) => <OrderCard key={order.id} order={order} />)
      )}
    </div>
  );
}
